import React from 'react';
import useAnalyticsPage from '../../web-analytics/hooks/useAnalyticsPage';
import { Page } from '../../web-analytics/Page';
import { FacebookSettings } from '../../facebook/components/FacebookSettings';
import { useIsFacebookEnabled } from '../../social-posting/hooks/useIsFacebookEnabled';

export const TeamIntegrations = () => {
  useAnalyticsPage(Page.INTEGRATIONS);
  const { isFacebookEnabled } = useIsFacebookEnabled();

  return (
    <div>
      <div className="integrations__container">{isFacebookEnabled && <FacebookSettings />}</div>
    </div>
  );
};
